var _image;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "50px",
    height: "25px",
    viewBox: "0 0 50 25",
    enableBackground: "new 0 0 50 25",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _image || (_image = /*#__PURE__*/React.createElement("image", {
    id: "image0",
    width: 50,
    height: 25,
    x: 0,
    y: 0,
    href: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAZCAMAAABEio12AAAABGdBTUEAALGPC/xhBQAAACBjSFJN AAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAA9lBMVEUAOaYEPKcALKBWe8T/ ///8/P4CO6cAOKYAM6MBOqYORKtKc8AANKQFPagAIJvx9PoAN6UAK6ACOqcANqUYTK6UrNq+zejb 4/PH1Oy+zOhpi8sMQqpVe8QBOaYAJ56Qqdjj6fWPqNj4+fw7Z7sALaENQ6pmiMkIP6kAJZ0vXbZX fMQBOqcALqEGPagAMqMEOaQDOaQGO6UFOqQGOqUDOKQHPKUALJ5YesH7+fr++/sAOrAAPbEALapM gdD+//9sMmNtM2NjLGCWU3Hzm5LplI7rlY/nKhXmKhXoKxbgJRPTGw7UHA/TKyHUKyHVLCLYLyPY LiPXKx9NfE/pAAAAAWJLR0QEj2jZUQAAAAd0SU1FB+YFGxUPOYFB+I0AAAC2SURBVDjLY2BAAYxM zCysLPgBXDEbyVrYOThJ0sLOycDFzcNLihZGdj5ufgFBNiFitXAKi4iKibNISEqxEW0Lp4C0KJAp w8kuS7TDeOXkFRSVlFUYibZFVkBVTV1DU4tDm4RAltUR0NXTEyIyxPRBwMDQyMDYyERf39TMnMXC Ej9gsEIB1ja2LHaEbLFHAQ6OTs4urvgBgxsKcPfw9PImABh8UICvj59/gD9+wBBIMhjVMmy0AACR SeK3m1l0BgAAACV0RVh0ZGF0ZTpjcmVhdGUAMjAyMi0wNS0yN1QyMToxNTo1NyswMDowMKObczwA AAAldEVYdGRhdGU6bW9kaWZ5ADIwMjItMDUtMjdUMjE6MTU6NTcrMDA6MDDSxsuAAAAAAElFTkSu QmCC"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChile);
export default __webpack_public_path__ + "static/media/chile.e21ec0f9ddc21e8d3cd5463ea45f1efa.svg";
export { ForwardRef as ReactComponent };